import { createAction, ActionsUnion } from "../utils/utils";

// ACTIONS TYPES
export enum ColumnActionsEnum {
  SET_HIDING_TEST_COLUMN_STATUS = "Set common hiding column status"
}

// ACTION CREATORS
export const columnActions = {
  setHidingColumnStatus: (
    name: string,
    isVisible: boolean,
    activeSubmenu: State.ColumnOptions
  ): Api.AnyItem =>
    createAction(ColumnActionsEnum.SET_HIDING_TEST_COLUMN_STATUS, {
      name,
      isVisible,
      activeSubmenu
    })
};

export type ColumnActions = ActionsUnion<Api.AnyItem>;
